import { Component, OnInit, OnDestroy } from '@angular/core'
import { Procedure } from 'src/app/_models/procedure.model'
import { Router, ActivatedRoute, Params } from '@angular/router'
import { ProfileService } from 'src/app/_services/profiles.service'
import { HorarioService } from 'src/app/_services/horario.service'
import { Profile } from 'src/app/_models/profile.model'
import { User } from 'src/app/_models/user.model'
import { AuthenticationService } from 'src/app/_services/authentication.service'
import { EnvironmentService } from 'src/app/_services/environment.service'
import Swal from 'sweetalert2'

@Component({
  selector: 'app-tramite',
  templateUrl: './tramite.component.html',
  styleUrls: ['./tramite.component.scss']
})
export class TramiteComponent implements OnInit, OnDestroy {
  selectedProcedure: Procedure
  procedureUrl: string
  currentProfile: Profile
  currentUser: User
  private swalInstance: any

  constructor (
    private profilesService: ProfileService,
    private authenticationService: AuthenticationService,
    private horarioService: HorarioService,
    private router: Router,
    private envService: EnvironmentService,
    private route: ActivatedRoute
  ) {}

  checkUserToken () {
    // let isTokenValid = false;
    this.authenticationService.checkUserToken().subscribe(
      (response: any) => {},
      error => {}
    )
  }

  ngOnInit () {
    this.paramValidation(this.route.snapshot.params)
    const ifr: HTMLIFrameElement = document.createElement('iframe')
    ifr.setAttribute('id', 'embeeded-frame')
    ifr.setAttribute('frameborder', '0')
    document.getElementById('iframe-goes-here').appendChild(ifr)
    this.route.params.subscribe(async (params: Params) => {
      this.swalInstance = Swal.fire({
        title: 'Cargando... ',
        text: 'Estamos preparando el contenido',
        icon: 'info',
        allowOutsideClick: false,
        onOpen: () => {
          Swal.showLoading()
        }
      })
      this.paramValidation(params)
      if (this.procedureUrl !== undefined) {
        let iframeUrl = this.procedureUrl
        if (this.currentProfile && this.currentUser) {
          const enHorario = await this.horarioService.getIsinhour(
            this.currentUser
          )
          this.checkUserToken();
          
          const iframeUrlParams = this.createUrlParams(
            this.currentProfile,
            this.currentUser
          )
          if (iframeUrlParams.length > 0) {
            iframeUrl += '?' + iframeUrlParams
          }
          if (!enHorario.cancontinue){
            // cambiar iframeurl
            iframeUrl = this.envService.htmlFormFueraHorario;
          }
        }
        ifr.contentWindow.location.replace(iframeUrl)
        ifr.click()
        ifr.onload = () => {
          console.log('El contenido del iframe se ha cargado completamente.')
          // Aquí puedes realizar acciones adicionales después de que el iframe se haya cargado+
          this.swalInstance.close()
        }

        //console.log('Aca si va')
      } else {
        console.log('Aca regresa')
        this.swalInstance.close()
        this.router.navigate(['/tramites'])
      }
    })
  }

  createUrlParams (profile: Profile, user: User) {
    let urlParams = ''
    // Usuario Portal
    const usuarioPortal = user.UserName ? user.UserName : ''
    if (usuarioPortal) {
      urlParams += this.addParam(urlParams, 'usuarioPortal', usuarioPortal)
    }

    // Rol Usuario Portal
    const rolActual = profile.profile_name ? profile.profile_name : ''
    if (rolActual) {
      urlParams += this.addParam(
        urlParams,
        'rolUsuarioPortal',
        rolActual.toUpperCase()
      )
    }

    const procedureVersion = this.selectedProcedure.proc_version;
    if (procedureVersion){
      urlParams += this.addParam(urlParams, 'version', procedureVersion);
    }

    // Tipo de Identificacion Empresa
    if (rolActual !== 'Funcionario Subsidio') {
      urlParams += this.addParam(urlParams, 'tipoIdentificacionEM', 'NIT')
    }

    // No. de Identificación Empresa
    if (rolActual !== 'Funcionario Subsidio') {
      const noIdentificacionEmpresa = profile.profile_company_id
        ? profile.profile_company_id
        : ''
      if (noIdentificacionEmpresa) {
        urlParams += this.addParam(
          urlParams,
          'noIdentificacionEM',
          noIdentificacionEmpresa
        )
      }
    }

    // Razón Social
    if (rolActual !== 'Funcionario Subsidio') {
      const razonSocial = profile.profile_company ? profile.profile_company : ''
      if (razonSocial) {
        urlParams += this.addParam(urlParams, 'razonSocialEM', razonSocial)
      }
    }

    // Tipo de Identificacion Afiliado
    if (rolActual !== 'Funcionario Subsidio') {
      const tipoIdentificacionAfiliado = user.TipoIdentificacion
        ? user.TipoIdentificacion
        : '';
      let tipoId = "";
      if (tipoIdentificacionAfiliado) {
        switch(tipoIdentificacionAfiliado){
          case "CO1C":
            tipoId = "Cédula de Ciudadanía"
            break;
          case "CO1D":
            tipoId = "Carné Diplomático"
            break;
          case "CO1E":
            tipoId = "Cédula de Extranjería"
            break;
          case "CO1L":
            tipoId = "Registro Civil"
            break;
          case "CO1P":
            tipoId = "Pasaporte"
            break;
          case "CO1R":
            tipoId = "Salvoconducto de Permanencia"
            break;
          case "CO1S":
            tipoId = "Permiso Especial de Permanencia"
            break;
          case "CO1T":
            tipoId = "Tarjeta de Identidad"
            break;
          case "CO1M":
            tipoId = "Permiso por Protección Temporal"
            break;
          default:
            tipoId = "Cédula de Ciudadanía";
            break;
        }
        urlParams += this.addParam(
          urlParams,
          'tipoIdentificacion',
          tipoId
        )
      }
    }

    // No. de Identificación Afiliado
    if (rolActual !== 'Funcionario Subsidio') {
      const noIdentificacionAfiliado = user.NoIdentificacion
        ? user.NoIdentificacion
        : ''
      if (noIdentificacionAfiliado) {
        urlParams += this.addParam(
          urlParams,
          'noIdentificacion',
          noIdentificacionAfiliado
        )
      }
    }

    // Token
    const tokenUsuario = user.authToken ? user.authToken : ''
    if (tokenUsuario) {
      urlParams += this.addParam(urlParams, 'token', tokenUsuario)
    }
    return urlParams
  }

  addParam (currentUrl: string, newParam: string, newParamValue: string) {
    return currentUrl !== ''
      ? `&${newParam}=${encodeURIComponent(newParamValue)}`
      : `${newParam}=${encodeURIComponent(newParamValue)}`
  }

  paramValidation (params: Params) {
    this.checkUserToken()
    const id = +params.id
    // If there is a procedure ID
    if (id) {
      // console.log(id);
      this.currentProfile = this.profilesService.getSelectedProfile()
      this.currentUser = this.authenticationService.currentUserValue
      if (this.currentProfile) {
        this.selectedProcedure = this.profilesService.getProfileProcedure(id)
        this.procedureUrl = this.selectedProcedure
          ? this.selectedProcedure.proc_url
          : undefined
      } else {
        this.router.navigate(['/'], { relativeTo: this.route })
      }
    } else {
      // console.log(this.route);
    }
  }

  ngOnDestroy () {
    this.procedureUrl = undefined
  }
}
